import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation";
import { exportToExcel } from "./ExportCustomerData";
import {
  Table,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import services from "../../API/services";
import { getCustomersAction, usersSeletor } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import moment from "moment";
import ReactPaginate from "react-paginate";

const Customer = () => {

  const dispatch = useDispatch();
  const { customers, customersPagination } = useSelector(usersSeletor);
  const [searchVal, setSearchVal] = useState('')
  const [page, setPage] = useState(1)
  let itemPerPage = 50

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getCustomersAction(page, itemPerPage, searchVal));
    setPage(1)
  }, [page, searchVal]);

  useEffect(() => {
    if (customers) {
      setUserList(customers);
    }
  }, [customers]);

  const { AlertIcon } = Imagesdata || {};

  const [show, setShow] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(() => {
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    return nextMonth;
  });
  const [userList, setUserList] = useState([]);
  const [showUserList, setShowUserList] = useState([]);
  const [resetDate, setResetDate] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [showPagination, setShowPagination] = useState(true);

  const handleFromDateChange = (date) => {
    setFromDate(date);
    const nextMonthDate = new Date(date);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setToDate(nextMonthDate);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ ...validation, mode: "onSubmit" });

  const onSubmit = async (payload) => {
    const realPayload = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      name: payload.firstName + " " + payload.lastName,
      email: payload.email,
      mobile: payload.phoneNumber,
      role: 1,
      password: payload.password,
      propertyId: 1,
      designation: payload.designation,
    };
    try {
      const res = await services.user.addPropertyUserService(realPayload);

      if (res.status === 200) {
        reset();
        dispatch(getCustomersAction());
        setShow(false);
      }
    } catch (error) { }
  };

  const onError = (error) => { };
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Customers",
    sheet: "Customers",
  });

  const searchfilter = (toDate, fromDate) => {
    const results = userList.filter((item) => {
      if (!resetDate) return userList;
      return (
        new Date(item?.createdAt).getTime() >= new Date(fromDate).getTime() &&
        new Date(item?.createdAt).getTime() <= new Date(toDate).getTime()
      );
    });
    // setShowUserList(results);
  };
  useEffect(() => {
    searchfilter(toDate, fromDate);
    let x = toDate;
    let y = fromDate;
    if ((x != y && x) || y) {
      setResetDate(true);
    } else {
      setResetDate(false);
    }
  }, [toDate, fromDate]);
  useEffect(() => {
    setShowUserList(userList);
    setResetDate(false);
  }, [userList]);
  const resetFilter = () => {
    setShowUserList(userList);
    setResetDate(false);
  };

  useEffect(() => {
    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };
    const fetchCustomersData = async () => {
      const formattedFromDate = formatDate(fromDate);
      const formattedToDate = formatDate(toDate);
      let res = await services.user.getExportCustomers(formattedFromDate, formattedToDate);
      if (res.data.status === true) {
        setExportData(res.data.data || []);
      }
    };
    fetchCustomersData();
  }, [fromDate, toDate]);


  const viewExportDataInTable = () => {
    setShowUserList(exportData)
    setShowPagination(false)
  }

  const maxToDate = new Date(fromDate);
  maxToDate.setMonth(maxToDate.getMonth() + 1);

  return (
    <Layout
      title="Customer"
      extraButton="Export Table"
      extraBtnHandler={() => exportToExcel(exportData)}
      searchfilter={searchfilter}
      searchType="date"
      setFromDate={handleFromDateChange}
      setToDate={setToDate}
      fromDate={fromDate}
      toDate={toDate}
      // openHandler={resetDate ? resetFilter : false}
      secondBtn={() => viewExportDataInTable()}
      secondbuttonTitle="View"
      maxToDate={maxToDate}
    >
      <div className="search mb-2 d-flex justify-content-center">
        <input
          type="text"
          className="form-control w-25 bg-light border-0"
          onChange={(e) => setSearchVal(e.target.value)}
          placeholder="Search by Name, Email, Mobile" />
      </div>
      <Table striped bordered hover className="userTable stink-table" ref={tableRef}>
        <thead>
          <tr>
            <th>S. No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Customer Referral Code</th>
            <th>Used Referral Code</th>
            <th>Last Logged In</th>
            <th>Register Date</th>
            <th>Registered With</th>
          </tr>
        </thead>
        <tbody>
          {showUserList.map((data, key) => {
            // if (data.name) {
            return (
              <tr key={key}>
                <td>{(page - 1) * itemPerPage + key + 1}</td>
                <td>{data.name ?? "Name not Available"}</td>
                <td>{data.email ?? "Email not Available"}</td>
                <td>{data.mobile ?? "Mobile Number not Available"}</td>
                <td>{data?.referralCode ? data?.referralCode : '-'}</td>
                <td>{data?.useReferralCode ? data?.useReferralCode : '-'}</td>
                <td>
                  {data?.lastLogged ? moment(data?.lastLogged).format("DD-MM-YYYY") : '-'}{data?.lastLogged && ', '}
                  {data?.lastLogged && moment(data?.lastLogged).format("HH:mm")}
                </td>
                <td>
                  {moment(data.createdAt).format("DD-MM-YYYY") ?? "N/A"}
                </td>
                <td>
                  {
                    (data?.platform == 1 && 'Web') || (data?.platform == 2 && 'App')
                  }
                </td>
              </tr>
            );
            // }
          })}
        </tbody>
      </Table>


      {
        showPagination && <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={(event) => {
            setPage(event.selected + 1);
          }}
          pageCount={customersPagination?.totalPages}
          forcePage={page - 1}
          className="paginationParent"
          previousLabel="<"
          activeClassName="activePaginationBtn"
          disabledClassName="disablePaginationBtn"
          renderOnZeroPageCount={null}
        />
      }



      <button type="button" onClick={onDownload} className="btn btn-primary">Export Table</button>


      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New user details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form"
            onSubmit={handleSubmit(onSubmit, onError)}
          >
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <p>New user details</p>
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="firstName"
                    text="First Name"
                    type="text"
                    autoFocus={true}
                    placeholder="Enter first name"
                    field={"firstName"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.firstName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"firstName"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="lastName"
                    text="Last Name"
                    type="text"
                    placeholder="Enter Last name"
                    field={"lastName"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.lastName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"lastName"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="phoneNumber"
                    text="Phone No."
                    type="text"
                    placeholder="Enter phone number"
                    field={"phoneNumber"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.phoneNumber?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"phoneNumber"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="email"
                    text="Email address "
                    type="email"
                    placeholder="Enter email address"
                    field={"email"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.email?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"email"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="designation"
                    text="Designation"
                    type="text"
                    placeholder="Enter designation"
                    field={"designation"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.designation?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"designation"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="password"
                    text="Create Password"
                    type="password"
                    placeholder="Enter new password"
                    field={"password"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.password?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"password"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="confirmPassword"
                    text="Confirm Password"
                    type="password"
                    placeholder="Enter confirm password"
                    field={"confirmPassword"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.confirmPassword?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage
                          errors={errors}
                          name={"confirmPassword"}
                        />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="form-group">
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Customer;
